import type { SafetyPassportPayload } from "@miter/types/contracts";
import { Card, CardContent, UserInfo } from "ui2";

type TeamMemberInfoProps = {
  teamMember: SafetyPassportPayload["team_member"];
  companyName: string;
};

const TeamMemberInfo = ({ teamMember, companyName }: TeamMemberInfoProps): React.JSX.Element => {
  const { photo_url, full_name, title } = teamMember;

  return (
    <Card className="tw:shrink-0 tw:rounded-t-none tw:border-none tw:px-4">
      <CardContent data-theme="new">
        <UserInfo
          size="lg"
          full_name={full_name}
          imageUrl={photo_url ?? undefined}
          secondary={`${title ?? "Employee"} at ${companyName}`}
        />
      </CardContent>
    </Card>
  );
};

export default TeamMemberInfo;
